<app-home-section-main></app-home-section-main>
<app-home-section-pc></app-home-section-pc>
<app-home-section-movil></app-home-section-movil>
<app-home-section-plans></app-home-section-plans>
<app-home-section-feature></app-home-section-feature>
<app-footer></app-footer>
